export default "__VITE_ASSET__BlDa91N4__"